module.exports = __webpack_public_path__ + "img/designer-room.1bea1121.png";